// Modules
import styled from 'styled-components'

export const BottomSheetWrapper = styled.div`
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    * > {
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    }
`

export const BottomSheetTitleContainer = styled.h1`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1.5rem 1.5rem 2rem 1.5rem;

    button {
        display: flex;
        align-items: flex-start;
        border: 0;
        background: transparent;
        cursor: pointer;
    }
`

export const BottomSheetTitle = styled.h1`
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: 0;
    color: #363636;
`
export const BottomSheetContent = styled.div`
    width: 100%;
    flex: 1 0;
    overflow: auto;
    padding: 0 1.5rem;

    p,
    li {
        color: #666;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;
        font-size: 1rem;
    }

    p span {
        color: #1636a5;
        font-weight: 500;
    }

    ul {
        margin-left: 1.25rem;
        li {
            list-style-type: disc;
            margin: 0;
        }
    }

    a {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        text-decoration: none;
    }
    div.container_illustration {
        margin: 1rem 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    h2 {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5rem;
        letter-spacing: 0;
        color: #363636;
        margin-bottom: 0.5rem;
    }
`
export const BottomSheetButtonWrapper = styled.div`
    padding: 1.5rem 1rem;
    width: 100%;
    display: flex;
    align-self: flex-end;
    background-color: #fefefe;
    border-top: #c6c6c6 1px solid;
`

export const CustomButton = styled.a`
    text-align: center;
    line-height: inherit;
    text-decoration: none;
    font-size: inherit;
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    color: var(--theme-ui-colors-white);
    background-color: var(--theme-ui-colors-primary);
    border: 0;
    border-radius: 4px;
    width: 100%;
    border-radius: 8px;
    font-family: Montserrat, 'Dasa Sans', sans-serif;
    font-weight: 600;
    transition: all 200ms;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-top: 1em;
    padding-bottom: 1em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    font-size: 1em;
    height: 3em;
    background-color: var(--theme-ui-colors-brand-primary-40);
    color: var(--theme-ui-colors-white);
`
